import { render } from "./DashboardTemplate.vue?vue&type=template&id=343a118f"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__